import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
// material
import { Divider, IconButton, MenuItem } from '@mui/material';
// component
import Iconify from '../../../components/Iconify';
import MenuPopover from '../../../components/MenuPopover';

// ----------------------------------------------------------------------

export default function UserMoreMenu({ item, status, id, handleDelete, handleEnable, handleDisable, handleEdit }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const navigation = useNavigate();

  const handleCloseMenu = () => {
    setIsOpen(null);
  };

  const handleOpenMenu = (event) => {
    setIsOpen(event.currentTarget);
  };

  const handleEnableClick = (id) => {
    handleEnable(id);
    setIsOpen(false);
  };
  const handleDeleteClick = (id) => {
    handleDelete(id);
    setIsOpen(false);
  };
  const handleDisableClick = (id) => {
    handleDisable(id);
    setIsOpen(false);
  };

  const handleViewClick = () => {
    navigation(`/user/${id}`, {
      state: location,
    });
  };

  const handleEditClick = () => {
    handleEdit(item);
    setIsOpen(false);
  };

  return (
    <>
      {/* <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton> */}

      <MoreMenuButton
        open={isOpen}
        onClose={handleCloseMenu}
        onOpen={handleOpenMenu}
        actions={
          <>
            <MenuItem onClick={handleViewClick}>
              <Iconify icon={'carbon:view'} />
              {t('view')}
            </MenuItem>

            <MenuItem onClick={handleEditClick}>
              <Iconify icon={'eva:edit-fill'} />
              {t('edit')}
            </MenuItem>

            <MenuItem onClick={() => handleEnableClick(id)} disabled={status === 'Active'}>
              <Iconify icon={'eva:checkmark-circle-2-fill'} />
              {t('enable')}
            </MenuItem>

            <MenuItem onClick={() => handleDisableClick(id)} disabled={status === 'Inactive'}>
              <Iconify icon={'ep:circle-close'} />
              {t('disable')}
            </MenuItem>

            <Divider sx={{ borderStyle: 'dashed' }} />

            <MenuItem onClick={() => handleDeleteClick(id)} sx={{ color: 'error.main' }}>
              <Iconify icon={'eva:trash-2-outline'} />
              {t('delete')}
            </MenuItem>
          </>
        }
      />

      {/* <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} />
          Delete
        </MenuItem>
        <MenuItem sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" sx={{ color: 'error.main' }} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
      </Menu> */}
    </>
  );
}

// ----------------------------------------------------------------------

MoreMenuButton.propTypes = {
  actions: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
};

function MoreMenuButton({ actions, open, onOpen, onClose }) {
  const ref = useRef(null);
  return (
    <>
      <IconButton ref={ref} size="large" color="inherit" sx={{ opacity: 0.7 }} onClick={onOpen}>
        <Iconify icon={'eva:more-vertical-fill'} width={20} height={20} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={ref.current}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        sx={{
          mt: -0.5,
          width: 'auto',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 2, width: 20, height: 20 },
          },
        }}
      >
        {actions}
      </MenuPopover>
    </>
  );
}
